// @flow
import { thunkProgress } from 'redux-progress';
import hamletFetchEligibleAutoRenewal from 'modules/checkout/payment/duck/api/fetchEligibleAutoRenewal';

export const FETCH_ELIGIBLE_AUTO_RENEWAL = 'checkout/payment/FETCH_ELIGIBLE_AUTO_RENEWAL';

export const fetchEligibleAutoRenewal = (cartId: string) =>
  thunkProgress(FETCH_ELIGIBLE_AUTO_RENEWAL, hamletFetchEligibleAutoRenewal(cartId));
